import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks, siteInfo } from '@/mocks/site';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-300 ${
        scrolled || !isHome
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap cursor-pointer">
            <div className="w-9 h-9 md:w-10 md:h-10 rounded-lg bg-primary-500 flex items-center justify-center">
              <i className={`ri-basketball-line text-background-50 text-lg md:text-xl`}></i>
            </div>
            <div>
              <span className={`font-heading text-xl md:text-2xl font-bold tracking-wide ${
                scrolled || !isHome ? 'text-foreground-900' : 'text-background-50'
              }`}>
                {siteInfo.name}
              </span>
            </div>
          </Link>

          <div className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 whitespace-nowrap cursor-pointer ${
                  location.pathname === link.href
                    ? scrolled || !isHome
                      ? 'bg-primary-50 text-primary-600'
                      : 'bg-background-50/20 text-background-50'
                    : scrolled || !isHome
                      ? 'text-foreground-700 hover:text-foreground-900 hover:bg-background-100'
                      : 'text-background-50/80 hover:text-background-50 hover:bg-background-50/10'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about#contact"
              className="px-5 py-2 rounded-full text-sm font-medium border whitespace-nowrap cursor-pointer transition-all duration-200 hover:opacity-80"
              style={{
                borderColor: scrolled || !isHome ? 'oklch(var(--foreground-300))' : 'rgba(255,255,255,0.5)',
                color: scrolled || !isHome ? 'oklch(var(--foreground-700))' : 'oklch(var(--background-50))',
              }}
            >
              登录
            </Link>
            <Link
              to="/register"
              className="px-5 py-2 rounded-full text-sm font-bold bg-primary-500 text-background-50 whitespace-nowrap cursor-pointer transition-all duration-200 hover:bg-primary-600"
            >
              立即注册
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            aria-label="菜单"
          >
            <i className={`text-xl ${scrolled || !isHome ? 'ri-menu-line text-foreground-900' : 'ri-menu-line text-background-50'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70">
          <div className="px-4 py-3 flex flex-col gap-1">
            {navLinks.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={`px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                  location.pathname === link.href
                    ? 'bg-primary-50 text-primary-600'
                    : 'text-foreground-700 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="flex gap-3 mt-2 pt-3 border-t border-background-200/70">
              <Link
                to="/about#contact"
                className="flex-1 text-center py-2.5 rounded-full text-sm font-medium border border-foreground-300 text-foreground-700 whitespace-nowrap cursor-pointer"
              >
                登录
              </Link>
              <Link
                to="/register"
                className="flex-1 text-center py-2.5 rounded-full text-sm font-bold bg-primary-500 text-background-50 whitespace-nowrap cursor-pointer"
              >
                立即注册
              </Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}